export const deliveryKeys = {
  reservation: 'reservation',
  takeaway: 'takeaway',
  delivery: 'delivery',
};

export const mainTabsKeys = {
  configs: 'configs',
  times: 'times',
};
